import { EXCHANGE } from '@/constants';
import { faker } from '@faker-js/faker';

const tokens = Object.values(EXCHANGE.TOKENS);

const mockExchangeBalance = (denom) => {
  const item = {
    amount: faker.string.numeric({
      length: { min: 2, max: 4 },
      allowLeadingZeros: false,
    }),
    denom,
  };
  return item;
};

const mockExchangeBalances = () =>
  tokens.map((denom) => mockExchangeBalance(denom));

const mockExchangeTransaction = (wallet) => {
  const denom = faker.helpers.arrayElement(tokens);
  const isPurchase = faker.datatype.boolean();
  const recipient = isPurchase
    ? wallet
    : `did:com:1${faker.string.alphanumeric({ length: 39 })}`;
  const sender = isPurchase ? 'AML Manager' : wallet;
  const item = {
    amount: faker.string.numeric({
      length: { min: 2, max: 5 },
      allowLeadingZeros: false,
    }),
    created_at: faker.date.past(),
    denom,
    id: faker.string.uuid(),
    is_purchase: isPurchase,
    recipient,
    sender,
    tx_hash: faker.string.alphanumeric(64),
  };
  return item;
};

const mockExchangeTransactions = ({ wallet, items = 10 } = {}) =>
  faker.helpers.multiple(() => mockExchangeTransaction(wallet), {
    count: items,
  });

export {
  mockExchangeBalance,
  mockExchangeBalances,
  mockExchangeTransaction,
  mockExchangeTransactions,
};
